import React, { useContext, useEffect } from 'react';
import { RicosContext, PluginsEventsContext } from 'ricos-context';
import { AUDIO_TYPE } from 'wix-rich-content-common';
import HtmlComponent from 'wix-rich-content-plugin-html/libs/HtmlComponent';
import { AUDIO_TYPES } from '../consts.js';
import 'ricos-types';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const AudioEmbedViewer = ({ componentData, settings, nodeId }) => {
  const { isMobile } = useContext(RicosContext);
  const pluginsEvents = useContext(PluginsEventsContext) || {};
  const {
    audio: {
      src: { url }
    },
    html
  } = componentData;
  const htmlCompProps = {
    componentData: {
      html,
      source: "html",
      containerData: {
        width: {
          custom: "100%"
        },
        height: {
          custom: "100%"
        },
        url
      }
    },
    settings,
    isMobile
  };
  useEffect(() => {
    var _a;
    nodeId && ((_a = pluginsEvents == null ? void 0 : pluginsEvents.publishMediaPluginsDetails) == null ? void 0 : _a.call(pluginsEvents, {
      pluginId: AUDIO_TYPE,
      nodeId,
      creator: void 0,
      title: void 0,
      track_duration: void 0,
      type: AUDIO_TYPES.spotify,
      url
    }));
  }, []);
  return /* @__PURE__ */ React.createElement(HtmlComponent, __spreadValues({}, htmlCompProps));
};

export { AudioEmbedViewer as default };
//# sourceMappingURL=audio-embed-viewer.js.map
